export const PRESENTATIONS_FETCH = 'PRESENTATIONS/FETCH';
export const PRESENTATIONS_FETCH_SUCCESS = 'PRESENTATIONS/FETCH_SUCCESS';
export const PRESENTATIONS_FETCH_FAILURE = 'PRESENTATIONS/FETCH_FAILURE';
export const PRESENTATIONS_DELETE_PRESENTATION =
  'PRESENTATIONS/DELETE_PRESENTATION';
export const PRESENTATIONS_DELETE_PRESENTATION_SUCCESS =
  'PRESENTATIONS/DELETE_PRESENTATION_SUCCESS';
export const PRESENTATIONS_DELETE_PRESENTATION_FAILURE =
  'PRESENTATIONS/DELETE_PRESENTATION_FAILURE';
export const PRESENTATIONS_SAVE_PRESENTATION_SUCCESS =
  'PRESENTATIONS/SAVE_PRESENTATION_SUCCESS';
export const PRESENTATIONS_SAVE_PRESENTATION_FAILURE =
  'PRESENTATIONS/SAVE_PRESENTATION_FAILURE';
export const PRESENTATIONS_SEARCH = 'PRESENTATIONS/SEARCH';
export const PRESENTATIONS_SEARCH_SUCCESS = 'PRESENTATIONS/SEARCH_SUCCESS';
export const PRESENTATIONS_SEARCH_FAILURE = 'PRESENTATIONS/SEARCH_FAILURE';

const initialState = {
  list: [],
};

export const fetchPresentations = () => ({
  type: PRESENTATIONS_FETCH,
});

export const deletePresentation = id => ({
  type: PRESENTATIONS_DELETE_PRESENTATION,
  payload: { id },
});

export const presentationsReducer = (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case PRESENTATIONS_FETCH_SUCCESS:
    case PRESENTATIONS_SEARCH_SUCCESS: {
      return {
        ...state,
        list: [...payload],
      };
    }
    case PRESENTATIONS_DELETE_PRESENTATION_SUCCESS: {
      return {
        ...state,
        list: state.list.filter(presentation => presentation.id !== payload.id),
      };
    }
    case PRESENTATIONS_SAVE_PRESENTATION_SUCCESS: {
      let presentationIndex = state.list.findIndex(
        presentation => presentation.id === payload.id
      );

      if (presentationIndex === -1) {
        return {
          ...state,
          list: [
            { ...payload },
            ...state.list.filter(presentation => presentation.id),
          ],
        };
      }
      return {
        ...state,
        list: [
          ...state.list.slice(0, presentationIndex),
          { ...payload },
          ...state.list.slice(presentationIndex + 1),
        ],
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/presentations.reducer.js